import { CognitiveSearchFilterModel } from './CognitiveSearchFilterModel';

export class CognitiveFilterRequestModel {
  filters?: CognitiveSearchFilterModel[];
  orderBy?: string = 'score';
  page?: number;
  pageSize?: number;
  culture?: string = 'en-GB';
  hideSubReports?: boolean;
  publicSiteSearch?: boolean;
}

export class CognitiveSearchRequestModel extends CognitiveFilterRequestModel {
  searchTerm?: string;
  facetsMode?: 'NoFacets' | 'IncludeFacets';
  account?: string;
  userId?: string;
}

export class CognitiveImageSearchRequestModel extends CognitiveFilterRequestModel {
  searchTerm?: string;
  facetsMode?: 'NoFacets' | 'IncludeFacets';
  isCatwalk: boolean = false;
  account?: string;
  userId?: string;
}
